import { HTMLAttributes } from 'react';
import { NonIdealState, NonIdealStateProps } from './blueprint/nonIdealState';

export function ClarionNonIdealState(props: HTMLAttributes<HTMLDivElement> & NonIdealStateProps) {
  return <NonIdealState {...props} />;
}
